// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color } from "@werner/XDL/Utilities";
import { mergeWithCss } from "@werner/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

interface AutoCompleteItems {
    itemWrapper?: InjectableCss;
    headerText?: TypographyPresentationProps;
    itemText?: TypographyPresentationProps;
    focusedItemText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
}

const sharedItemTextStyles: TypographyPresentationProps = {
    size: 15,
    weight: 400,
    color: "text.main",
    css: css`
        letter-spacing: 0;
        line-height: 22px;
    `,
};

const headerSearchInputStyles: AutoCompleteItems = {
    itemWrapper: {
        css: css`
            padding: 0 16px;
            margin-bottom: 12px;
            max-width: 270px;
            text-overflow: ellipsis;
            overflow: hidden;
            &:last-child {
                margin-bottom: 0;
            }
        `,
    },
    headerText: {
        ...mergeWithCss(sharedItemTextStyles, {
            weight: 500,
            css: css`
                margin: 0 11px 12px;
                padding: 16px 0px 12px;
                border-bottom: 1px solid ${color("common.ui1")};
            `,
        }),
    },
    itemText: {
        ...sharedItemTextStyles,
    },
    focusedItemText: {
        ...mergeWithCss(sharedItemTextStyles, {
            weight: 500,
            css: css`
                background-color: ${color("common.ui2")};
            `,
        }),
    },
    link: {
        color: "text.main",
        typographyProps: {
            ...sharedItemTextStyles,
        },
    },
    focusedLink: {
        color: "text.main",
        typographyProps: {
            ...mergeWithCss(sharedItemTextStyles, {
                weight: 500,
            }),
        },
        css: css`
            background-color: ${color("common.ui2")};
        `,
    },
};

export default headerSearchInputStyles;
